<script setup lang="ts">
import PulsePill from "@/components/pulse/PulsePill.vue";
import PulseTimeAllocationDisplay from "@/components/pulse/PulseTimeAllocationDisplay.vue";
import { toRef } from 'vue';
import { useUserAllocationStats } from '@/composables/usePulseStats';
import type { PulseData } from '@/types/DataTypes';

interface Props {
  weekdays: PulseData;
  showTimeAllocation?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showTimeAllocation: true
});

// Convert props to reactive reference for the composable
const weekdaysRef = toRef(props, 'weekdays');

// Use the centralized user allocation calculation logic
const { stats: weekAllocation } = useUserAllocationStats(weekdaysRef);
</script>
<template>
  <div class="flex flex-col gap-1">
    <!-- Existing pulse pills -->
    <div class="flex gap-2 items-center">
      <PulsePill v-for="d in weekdays" :day="d" :key="d.date"/>
    </div>
    
    <!-- Time allocation display without legend -->
    <div v-if="showTimeAllocation && Object.keys(weekAllocation.allocation).length > 0" class="w-full">
      <PulseTimeAllocationDisplay
        :time-allocation="weekAllocation.allocation" 
        :show-unallocated="true" 
        :show-legend="false"
      />
    </div>
  </div>
</template>
